// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './language/langConfig'
import axios from 'axios'
import SlideVerify from 'vue-monoplasty-slide-verify'
import { ip,post,download } from '@/utils/http'
import { sip,spost } from '@/utils/httpSpreader'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import wx from "weixin-js-sdk"


Vue.use(ElementUI);
Vue.use(SlideVerify);

Vue.prototype.$wx = wx;
Vue.prototype.$ajax = axios;
Vue.prototype.$post = post;
Vue.prototype.$ip = ip;
Vue.prototype.$spost = spost;
Vue.prototype.$sip = sip;
Vue.prototype.$download = download;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js